import styled from "styled-components";
import { CloudDownloadOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

export const Container = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  padding: 25px;
  width: 504px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  flex-direction: column;
`;

export const QRCodeContainer = styled.div`
  max-width: 120px;
  max-height: 120px;
  align-self: center;
  margin-top: 30px;
`;

export const DownloadQRCodeTouchable = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  margin-top: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
    transition: 0.2s;
  }
`;

export const CloudDownloadIcon = styled(CloudDownloadOutlined)`
  margin-left: 5px;
`;

export const CopyLinkContainer = styled.div`
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 15px;

  &:hover {
    > span,
    svg {
      transition: opacity 0.2s;

      opacity: ${({ theme }) => theme.palette.action.hoverOpacity};
    }
  }

  > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 5px;
  }
`;

export const ButtonModal = styled(Button)`
  display: flex;
  border-radius: 20px !important;
  bottom: 20px;
  width: 129px;

  align-self: center;
`;
